import {Icons} from '@continuum/ui';

export function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Icons.spinner className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}
